/**
 * @generated SignedSource<<610228bd838e0cb32f522e730132f622>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccessModelSettings_awsAccessRoles$data = {
  readonly awsAccessRoles: {
    readonly externalID: string | null | undefined;
    readonly primaryRoleARN: string | null | undefined;
    readonly samplePrimaryTrust: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GatewayRolesForm_awsAccessRoles">;
  readonly " $fragmentType": "AccessModelSettings_awsAccessRoles";
};
export type AccessModelSettings_awsAccessRoles$key = {
  readonly " $data"?: AccessModelSettings_awsAccessRoles$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccessModelSettings_awsAccessRoles">;
};

import AccessModelSettingsRefetchQuery_graphql from './AccessModelSettingsRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": AccessModelSettingsRefetchQuery_graphql
    }
  },
  "name": "AccessModelSettings_awsAccessRoles",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GatewayRolesForm_awsAccessRoles"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AWSAccessRoles",
      "kind": "LinkedField",
      "name": "awsAccessRoles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryRoleARN",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "samplePrimaryTrust",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "93ef7e20d65fd88393693c6d4d9d8bde";

export default node;
